import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CrmsettingsService } from './crmsettings.service';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { SendMessageResponse } from '../pages/internal-chat-bot/internal-chat-bot.component';

@Injectable({
  providedIn: 'root'
})
export class SendSmsService {


  url = environment.serverAPI9 + "/api/sms";
  url1 = environment.serverAPI9 + "/api";

  whatsappVendorId: any;
  crmSettingsData: any;

  constructor(private http: HttpClient, private crmsettingsService: CrmsettingsService,
    private ecryptService: EcryptServiceService,) {

  }

  getAllWhatsAppChat(contactUid, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/view/${contactUid}?page=${Page}&size=${size}&sort=${sort}`);
  }


  getChatHistory(contactId, page: any, size: any, vendorId): Observable<any> {
    return this.http.get(`${this.url}/chat-history/${contactId}?page=${page}&size=${size}`);
  }

  getContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any
  ): Observable<{ contacts: any[], nextPage: number }> {

    // let accessToken = null;
    // const encrypted = localStorage.getItem('crmSettingsData');
    // if (encrypted) {
    //   const decrypted = this.ecryptService.decryptionAES(encrypted);
    //   this.crmSettingsData = JSON.parse(decrypted);
    //   console.log("CRM Settings Data:", this.crmSettingsData);
    //   accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
    //   console.log(accessToken);
    // }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url}/contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }

  sendMessage(MessageData: any, vendorId: number): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();

    return this.http.post<Response[]>(`${this.url}/sendNew`, MessageData);
  }

    smsSend(forms: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/sendSms/twilio`, forms);
  }

  sendMedia(MessageData: any): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();
      params = params
        .set('act', accessToken)
        .set('cpid', currentPhoneNumberId)
    

    return this.http.post<Response[]>(`${this.url}/send-media`, MessageData, { params });
  }
  sendMediaChat(MessageData: any): Observable<Response[]> {

    let params = new HttpParams();

    return this.http.post<Response[]>(`${this.url}/send-media`, MessageData);
  }

  getMessagesbyPhoneno(phoneno): Observable<Object> {
    return this.http.get(`${this.url}/chatView/${phoneno}`);
  }

  getBlockedUsers(): Observable<Object> {
    return this.http.get(`${this.url1}/blockList`);
  }

  getVendorId(): Observable<Object> {
    return this.http.get(`${this.url1}/vendor/id`);
  }

  getContactsDataWithSearch(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any,
    whatsappVendorId: any,
    search: string = ''
  ): Observable<{ contacts: any[], nextPage: number }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);

    if (search && search.trim().length > 0) {
      params = params.set('search', search.trim());
    }

    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url}/contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }



  getInternalContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc'
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');

    //  let commonContactUid= localStorage.getItem('userId')

    let commonContactUid = 1845;
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{
      chatData: any; contactsPaginatePage: number, contacts: any[]
    }>(
      `${this.url1}/chatlogs/view`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.chatData.contactDetails,
        nextPage: response.chatData.contactsPaginatePage
      }))
    );
  }

  getInternalContactsDataSearch(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    search: string = ''
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');

    //  let commonContactUid= localStorage.getItem('userId')

    let commonContactUid = 1845;
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);

    if (search && search.trim().length > 0) {
      params = params.set('search', search.trim());
    }

    return this.http.get<{
      chatData: any; contactsPaginatePage: number, contacts: any[]
    }>(
      `${this.url1}/chatlogs/view`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.chatData.contactDetails,
        nextPage: response.chatData.contactsPaginatePage
      }))
    );
  }

  getAllChat(contactUid): Observable<Object> {
    // let fromID= 1845;
    return this.http.get(`${this.url1}/chatlogs/history/${contactUid}`);
  }


  sendMessageInternal(MessageData: any, vendorId: number): Observable<Response[]> {

    //  let commonContactUid=1845;
    //  MessageData['fromUser']= commonContactUid;
    return this.http.post<Response[]>(`${this.url1}/chatlogs/send`, MessageData);
  }

  sendMediaChatInternal(MessageData: any): Observable<Response[]> {

    //  let commonContactUid=1845;
    //  MessageData['fromUser']= commonContactUid;
    return this.http.post<Response[]>(`${this.url1}/chatlogs/send-media`, MessageData);
  }

  getAllChatBot(contactUid): Observable<Object> {
    return this.http.get(`${this.url1}/chatbot/${contactUid}`);
  }


  updateRead(contactUid): Observable<Object> {
    return this.http.get(`${this.url1}/chatlogs/read/${contactUid}`);
  }

  sendMessageChatBot(MessageData: any, vendorId: number): Observable<SendMessageResponse> {
    return this.http.post<SendMessageResponse>(`${this.url1}/chatbot/`, MessageData);
  }

  getSupportContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url1}/support-contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }

    sendSupportMessage(MessageData: any, vendorId: number): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    // if (encrypted) {
    //   const decrypted = this.ecryptService.decryptionAES(encrypted);
    //   this.crmSettingsData = JSON.parse(decrypted);

    //   accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
    //   console.log(accessToken);
    //   currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    // }

    currentPhoneNumberId = "729877163537894";
    let params = new HttpParams();

    return this.http.post<Response[]>(`${this.url1}/support-chat-send`, MessageData);
  }

  getAllSupportChat(contactUid, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url1}/supportview/${contactUid}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
